import { useState, FormEvent } from "react";

export default function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const message = (form.elements.namedItem("message") as HTMLTextAreaElement)?.value || "";
    if (message.length > 500) {
      return;
    }
    setLoading(true);
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value as string);
    });
    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch (err) {
      console.error("送信エラー:", err);
      alert("送信に失敗しました。お手数ですが、時間をおいて再度お試しください。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-20" style={{ background: "linear-gradient(135deg, #0a1628 0%, #0d2b5e 50%, #1a3a7a 100%)" }}>
      <div className="max-w-2xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3">
            まずは無料でモック作成を依頼
          </h2>
          <p className="text-gray-300 text-sm leading-relaxed">
            モック作成だけのご依頼も喜んで対応いたします。
まずはお気軽にご相談ください。
          </p>
        </div>

        {!submitted ? (
          <form
            id="contactForm"
            name="contact"
            data-netlify="true"
            netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
            className="bg-white rounded-2xl p-8 space-y-5"
          >
            <input type="hidden" name="form-name" value="contact" />
            <input type="hidden" name="bot-field" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label className="block text-xs font-bold text-gray-700 mb-1.5">
                  会社名 <span className="text-red-500">*</span>
                </label>
                <input
                  name="company"
                  required
                  placeholder="例:株式会社〇〇"
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-blue-400 transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-700 mb-1.5">
                  お名前 <span className="text-red-500">*</span>
                </label>
                <input
                  name="name"
                  required
                  placeholder="例:山田 太郎"
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-blue-400 transition-colors"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-700 mb-1.5">
                メールアドレス <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                required
                placeholder="例:yamada@example.co.jp"
                className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-blue-400 transition-colors"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-700 mb-1.5">ご相談内容(任意)</label>
              <textarea
                name="message"
                maxLength={500}
                rows={4}
                placeholder="現在の課題やご要望があればお聞かせください"
                className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-blue-400 transition-colors resize-none"
              ></textarea>
              <p className="text-xs text-gray-400 mt-1">500文字以内</p>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white font-bold py-4 rounded-full transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              {loading ? "送信中..." : "無料作成を依頼する"}
            </button>
            <p className="text-center text-xs text-gray-400">1営業日以内にご連絡いたします。</p>
          </form>
        ) : (
          <div className="bg-white rounded-2xl p-10 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
              <i className="ri-check-double-line text-blue-600 text-3xl"></i>
            </div>
            <h3 className="text-xl font-extrabold text-gray-900 mb-2">送信完了しました</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              1営業日以内に担当者よりご連絡いたします。<br />しばらくお待ちください。
            </p>
            <div className="bg-blue-50 border border-blue-100 rounded-xl p-5">
              <p className="text-sm font-semibold text-gray-700 mb-3">今すぐ打ち合わせ日時を確定できます</p>
              <a
                href="https://www.jicoo.com/t/kAJcGlv7ILeq/e/9pBbhiUr"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-6 py-3 rounded-full transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line text-base"></i>
                続けて日時を予約する
              </a>
              <p className="text-xs text-gray-400 mt-2">Jicooの予約画面が開きます(所要時間30秒)</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
